<template>
  <div>
    <!--滑动5秒才能关闭弹窗-->
    <van-dialog v-model="visible" :showConfirmButton="false" class="custormTips4">
      <p class="title">重要打款公告</p>
      <div class="t-content">
        <p class="name">尊敬的平台用户:</p>
        <div class="text-content" @scroll="handleScroll">
          <p>
            您好，为严格贯彻落实国务院第 810
            号令及税务总局配套公告相关要求，依据实施细则规定，自即日起，通过平台结算，需完成人脸识别认证，操作链接如下，点击即可完成认证流程：
          </p>
          <br />
          <span style="color: #006EEF;" @click="open">
            https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx73576c3cf6b396f8&redirect_uri=https%3A%2F%2Fconfirm.serviceshare.com%2Fpages%2FYoufuSupport.html%23%2Funified-login?appKey=wx73576c3cf6b396f8&response_type=code&scope=snsapi_base&state=1767496543936305#wechat_redirect
          </span>
          <br />
          <p>
            若在个人认证过程中遇到任何问题，随时联系我们，我们将提供协助完成认证。此次调整给您带来的不便，我们深表歉意，衷心感谢您的理解与支持
          </p>
        </div>
      </div>
      <div class="t-btns-box">
        <div class="t-btns" :class="{ disabled: countdown > 0 }" @click="handleClose">
          {{ countdown > 0 ? `我已阅读重要打款公告(${countdown}s)` : '我已阅读重要打款公告' }}
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import config from '@/configs/config'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      require: true
    },
    slideId: {
      type: Boolean,
      default: true,
      require: true
    }
  },
  data() {
    return {
      countdown: 0, //倒计时
      hasScrolled: false,
      timer: null //计时器
    }
  },
  watch: {},
  mounted() {
    if (this.visible) {
      // 重置状态
      this.hasScrolled = false
      if (!this.slideId) {
        this.countdown = 5
      } else {
        this.countdown = 0
      }
      clearInterval(this.timer)
    }
  },

  methods: {
    open() {
      location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx73576c3cf6b396f8&redirect_uri=https%3A%2F%2Fconfirm.serviceshare.com%2Fpages%2FYoufuSupport.html%23%2Funified-login?appKey=wx73576c3cf6b396f8&response_type=code&scope=snsapi_base&state=1767496543936305#wechat_redirect'
    },
    // 处理滚动事件
    handleScroll() {
      if (!this.hasScrolled) {
        this.hasScrolled = true
        this.startCountdown()
      }
    },

    // 初始化倒计时
    startCountdown() {
      if (!this.slideId) {
        this.timer = setInterval(() => {
          this.countdown -= 1
          if (this.countdown <= 0) {
            clearInterval(this.timer)
          }
        }, 1000)
      } else {
        this.countdown = 0
      }
    },
    // 处理关闭操作
    handleClose() {
      if (this.countdown > 0) return
      if (this.countdown <= 0 && !this.slideId) {
        this.addUserNotice(2)
      }
      this.$emit('close')
    },
    async getUserInfo() {
      // 身份信息
      const res = await tuhu.fetch(`${config.apis.GET_USERINFO}`)
      if (res && res.code === '200') {
        const userInfoPromise = tuhu._setUserInfo(res.data) // 返回数据
        if (this.options && this.options.resolve) {
          this.options.resolve(userInfoPromise)
        }
      } else {
        tuhu.toast(res.message || '获取权限信息失败')
      }
    },
    //用户看过某个公告
    async addUserNotice(type) {
      try {
        let formdata = new FormData()
        formdata.append('type', type)
        const data = await tuhu.fetch(`${config.apis.ADD_USER_NOTICE}`, {
          method: 'post',
          body: new URLSearchParams({
            type: type
          }),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        if (data.code === '200') {
          await this.getUserInfo()
        } else {
          tuhu.toast(data.message)
        }
      } catch (error) {
        console.log('err', error)
        tuhu.toast(error)
      }
    }
  }
}
</script>

<style scoped lang="less">
.custormTips4 {
  width: 16rem;
  height: 25rem;
  background: url('https://res.xiaokunkeji.cn/image/2023/12/12/3be777a1fa0846b68f11c88960bd7433.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  .title {
    height: 1.8rem;
    line-height: 1.8rem;
    font-size: 1.8rem;
    color: #aa6928;
    margin-top: 2.3rem;
    margin-left: 0.8rem;
  }

  .t-content {
    height: 16rem;
    padding: 0 1rem;
    font-size: 0.7rem;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #333333;
    .text-content {
      width: 14rem;
      height: 13rem;
      font-size: 0.8rem;
      overflow-y: scroll;
      word-wrap: break-word; /* 允许长单词换行 */
      overflow-wrap: break-word; 
      white-space: normal; 
      overflow-y: auto;
      overflow-x: hidden; 
      line-height: 1.2rem;
      p {
        text-indent: 2em !important;
      }
    }

    .name {
      height: 0.8rem;
      font-size: 0.8rem;
      width: 14rem;
      text-align: left;
      margin: 1.5rem 0 0.4rem 0;
    }

    .service-provider {
      text-align: right;
      margin-top: 1rem;
    }
  }
  .t-btns-box {
    width: 16rem;
    height: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    .t-btns {
      background: url('../../../imgs/t-btn-null.png') no-repeat;
      background-size: 100% 100%;
      width: 14rem;
      height: 3rem;
      line-height: 1.5rem;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 0.8rem;
      font-weight: bold;
    }
    .t-btns.disabled {
      border-radius: 0.25rem;
      background: url('../../../imgs/t-btn-gray.png') no-repeat;
      background-size: 100% 100%;
      cursor: not-allowed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/sildePopup2.vue